/**
 * @Author Valon.Ye
 * @Date 2022/06/15 15:54:54
 * @FilePath \business\src\components\Loading\global.tsx
 * @Description
 */
import { render, unmountComponentAtNode } from 'react-dom'
import Loading from '@/components/Loading'

const GlobalLoading = () => <Loading loading />

GlobalLoading.currentKey = ''

GlobalLoading.show = () => {
  GlobalLoading.currentKey = Math.random().toString(32).slice(2).concat(Date.now().toString())
  const div = document.createElement('div')
  div.id = GlobalLoading.currentKey
  /** @ts-ignore */
  render(<GlobalLoading />, div)
  document.body.appendChild(div)
}

GlobalLoading.hide = () => {
  const div = document.getElementById(GlobalLoading.currentKey)
  if (!document.body.contains(div)) return
  unmountComponentAtNode(div!)
  GlobalLoading.currentKey = ''
  document.body.removeChild(div!)
}

export default GlobalLoading
